import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { agentCreatePath, hasCreateResumeIntent } from '@/lib/creationPlan';

/**
 * Standalone /create bookmarks without a project open Create with agent instead.
 * When a resume query or agent handoff state is present, render the original page.
 */
export function AgentOnlyCreateRoute({ flowId = '', children = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const resume = hasCreateResumeIntent(searchParams, location.state);

  useEffect(() => {
    if (resume) return undefined;
    navigate(agentCreatePath({ flowId }), { replace: true });
    return undefined;
  }, [flowId, navigate, resume]);

  if (resume && children) return children;

  return (
    <div
      className="min-h-screen bg-[#0b0e13] flex items-center justify-center text-sm text-[#9CA3AF]"
      data-testid="agent-create-redirect"
    >
      Opening Create with agent…
    </div>
  );
}

export default AgentOnlyCreateRoute;
